webpackJsonp([1],{

/***/ 130:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 131:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 132:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 133:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/feidie.a4c942f.png";

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-404.489f529.png";

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.a1685d6.png";

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAuCAYAAADUfRIMAAAAAXNSR0IArs4c6QAABF1JREFUWAm1mGlPE1EUhmkpWINVmrIYjUYjkd2Y+AETP6CyhkWQSmL8R/4SPxiXGAURJYAoogioLEFx3yKlAoprA/icptMMnZk70xYnuZk795zzPvecuXO5JSPjP11FRUX5VtJuK0M64+Xl5ee8Xu+rioqKOjMdl9lgOmOVlZWdxF+gZa6vr/9eW1vrmJ6e7tZrbioUYDviF2keDQL4L61zamrqmja2aVBK2eJyuS4jnKWJ6+4RwGcnJyfFnpGpM6Tc5R02ALxCy7YQycQWLCgomJ2fn59KO9OysrIat9t9HVGvBTA+LO84EokciNc+bkmiwzusxl3elS0QnwiL6uzs7OynlMtLSY8h1EWGOdyVV2wxnWEVRxdTSplS0ipg3bRtShpGgH+4BVm9NzTfpN8pJT1C8B3aDk3E6i7vkHYa4E29T1KZUtLDBPfSHAHxawN4Sw+UvuNtsLS0tIJyCtCfKGLy/AvfVr5LA1B8HZWXD78UkX78CyTI5vrJKm0lwz4rP9vylpSUHCRY3qET4A/eYQvAfiugjCszJcMDZDiA326ViNiArayurjbPzMwM2vlaZkqG+wiWEjkBfgfaBHDIDih2UygZ7iFDAe61EwH2Dd9GFs2wna9mN0CLi4t3YRTgfs1JcV9m0TSw04wofAymDVC+w51s3gIsMngaB5ZiwIdGk3okDpUzDWWSVVqsDolaFylrPat01IGvwSUKZdEEPB7PbaBlBo+EAWBfWaV1LJqxBJPjRw97qewwstMcsosCGKbVApyw81XZ3cz6qBNgTOQ8JU0LKDqZoVBoLj8//zmlPc2z3V5czZFjnCPHi9gkUrpF/4gDngQ8B1hOc5Zg7OIfxPcRMS9TIhIUPzkg8owsXjHWjrjl9ojJQxPwMDGvUwHHoRJM2Z4i9oZumwqMPQt7ZyAQGFpYWHjLc1LXBqhEMvsngN/RPeUETHUGmOz7ZKgGaAw8gdgHOzCTknNuJ5PsY7IfnYJNoRLM7McRE6FWVcbYttCk1L2U+rMTsCVUgpn9WGFh4Wc2BPnJYLm4cPUKmEn2EPPFDqyESjAZP6bUItSsAmPbSgvm5eV1AQ6pwLbQGHiULEKINqvEsOUImOpcZ7ILVr6OoBLM5B8hFqbbZCUm40DlAN7BJK8R89XM1zFUgpn9Q0q9hHCjmZhuzIdPh9/vvxoOh5d049FuUlCJADxCFnJEaUgUS3jezoGgHd/LZLystyUNlWBEHpDxCuB6vVhiH3surS03N/cSGX/X7ClBJZiMhwH/RNT0nxkagLufA0IL3/ElvuMVGU8ZKsGA77O4ftOtlWfFFWByTT6f7+Li4uKPtKACAXyPjCOI1iigYvJlZ2f34P82baioIXSXBbMK+KQ8J17saFKNNs7GctJMr7x6cRbXIKVeZ+yEflyAtHaOOfFfcJuSqQYh4wFKTcKu4zIG7A9NfhT3aD5y31SoCALuJ2MPsKpYhht+hYvPf7tiPzFN9f8BB9+/ITpxsAUAAAAASUVORK5CYII="

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/netvue_logo.a1685d6.png";

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(133)
}
var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(148),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9f7893fe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(131)
}
var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(146),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d26f4fb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(130)
}
var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(145),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-404",
    attrs: {
      "id": "scene"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(139)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "layer feidie",
    attrs: {
      "src": __webpack_require__(137),
      "data-depth": "0.30"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img404",
    attrs: {
      "src": __webpack_require__(138)
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("返回首页")])])
}]}

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-md-1 col-xs-1 back",
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(140),
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.commentTip))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 stars"
  }, [_c('ul', {
    staticClass: "list-inline"
  }, _vm._l((_vm.stars), function(star, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.starClicked(index)
        }
      }
    }, [_c('span', {
      class: ['glyphicon', {
        'glyphicon-star': star.active,
        'glyphicon-star-empty': !star.active
      }]
    })])
  }), 0)])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.submitText))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-10 col-xs-10"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(141),
      "alt": ""
    }
  })])
}]}

/***/ }),

/***/ 147:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 148:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row activities"
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('a', {
      attrs: {
        "href": item.target,
        "target": "_self"
      }
    }, [_c('div', {
      staticClass: "activity"
    }, [_c('div', {
      staticClass: "image-wrap"
    }, [_c('img', {
      attrs: {
        "src": item.imageUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text-wrap"
    }, [_c('p', [_vm._v(_vm._s(item.description))])])])])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEmptyList),
      expression: "isEmptyList"
    }]
  }, [_c('p', [_vm._v(_vm._s(_vm.emptyListTip))])])])
},staticRenderFns: []}

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nvui_activities_Activities__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nvui_activities_Activities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__nvui_activities_Activities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nvui_activities_Comment__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nvui_activities_Comment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__nvui_activities_Comment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nvui_error_404__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nvui_error_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__nvui_error_404__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    // https://router.vuejs.org/zh-cn/essentials/history-mode.html
    mode: 'history',
    routes: [
    // {path: '/', redirect: '/activities'},
    {
        path: '/',
        name: 'Activities',
        component: __WEBPACK_IMPORTED_MODULE_2__nvui_activities_Activities___default.a,
        meta: {
            title_key: 'activities_title'
        }
    }, {
        path: '/comment',
        name: 'Comment',
        component: __WEBPACK_IMPORTED_MODULE_3__nvui_activities_Comment___default.a
    }, { path: '*', component: __WEBPACK_IMPORTED_MODULE_4__nvui_error_404___default.a }]
}));

/***/ }),

/***/ 56:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(132)
}
var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(147),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(52);



// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// import bootflat & bootstrap

// import 'bootstrap/dist/css/bootstrap.min.css'



// import iView from 'iview'
// import 'iview/dist/styles/iview.css'


// import moment from 'moment'



// Vue.prototype.config = config
// Vue.prototype.$echarts = echarts
// Vue.prototype.$moment = moment
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].config.productionTip = false;

var defaultHeaders = {
    Accept: 'application/json, text/plain, */*; charset=utf-8',
    'Content-Type': 'application/json; charset=utf-8',
    Pragma: 'no-cache',
    'Cache-Control': 'no-cache'
    // 设置默认头
};__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_6_axios___default.a.defaults.headers.common, defaultHeaders);

// Vue.use(iView)
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.debug = false;
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.axios = __WEBPACK_IMPORTED_MODULE_6_axios___default.a.create();
// http请求拦截器
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.axios.interceptors.request.use(function (config) {
    // element ui Loading方法
    // loadinginstace = Loading.service({ fullscreen: true })
    // console.log('axios.req: ' + JSON.stringify(config))
    // console.log('## axios.req: ' + config.method + ', ' + config.url)
    return config;
}, function (error) {
    // loadinginstace.close()
    // Message.error({
    //     message: '加载超时'
    // })
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});
// http响应拦截器
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.axios.interceptors.response.use(function (response) {
    // 响应成功关闭loading
    // loadinginstace.close()
    // console.log('axios.resp: ' + JSON.stringify(response))
    // console.log('## axios.resp: ' + response.status + ', ' + JSON.stringify(response.data))
    return response;
}, function (error) {
    // loadinginstace.close()
    // Message.error({
    //     message: '加载失败'
    // })
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

// 解析 URL 参数
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.nvParseUrlParams = function () {
    var name, value;
    // 取得整个地址栏
    var str = location.href;
    var num = str.indexOf('?');
    // 取得所有参数   stringvar.substr(start [, length ]
    str = str.substr(num + 1);
    // 各个参数放到数组里
    var arr = str.split('&');
    for (var i = 0; i < arr.length; i++) {
        num = arr[i].indexOf('=');
        if (num > 0) {
            name = arr[i].substring(0, num);
            value = arr[i].substr(num + 1);
            this[name] = value;
            if (__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.debug) {
                console.log('[' + name + ']=' + value);
            }
            if (name === 'hl' && value !== undefined) {
                __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.nvSetLocale(value);
            }
        }
    }
};

// 获取语言, 根据不同浏览器厂商做适配
// PC:
// Chrome: 中文简体(zh-CN)/
// Safari: 中文简体(zh-CN)/

// Android monitor:
// Chrome: en-US, zh-CN(简体中文), zh-TW(繁体中文/粤语)

// iOS simulator:
// Safari: en-US, zh-CN(简体中文), zh-TW(繁体中文)
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.nvGetLanguage = function () {
    // console.log('window.navigator.language: ' + window.navigator.language)
    var language;
    if (__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.locale !== undefined) {
        language = __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.locale.toLowerCase();
    } else {
        language = window.navigator.language.toLowerCase();
    }
    var languages = ['de', 'en', 'es', 'fr', 'it', 'ja', 'pt', 'ru'];
    if (language.startsWith('zh-tw') || language.startsWith('zh') && language.endsWith('hant')) {
        return 'zh-Hant';
    } else if (language.startsWith('zh') || language.startsWith('cn')) {
        return 'zh-Hans';
    } else {
        for (var i = 0, len = languages.length; i < len; i++) {
            var matched = languages[i];
            if (language.startsWith(matched)) {
                return matched;
            }
        }
        return 'en';
    }
};

// 拼接本地资源路径
// prefix: */
// suffix: *
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.nvGetPath = function (prefix, suffix) {
    var path = prefix + __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.nvGetLanguage() + '/' + suffix;
    if (__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.debug) {
        console.log('path: ' + path);
    }
    return path;
};

// 读取本地静态资源中的 JSON 文件, 转化层 JSON 对象
// prefix = */
// suffix = *
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.nvGetJson = function (prefix, suffix, onFulfilled, onRejected) {
    var jsonPath = __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.nvGetPath(prefix, suffix);
    __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.axios.get(jsonPath).then(function (response) {
        if (__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.debug) {
            console.log('axios: path:' + jsonPath + ', response:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
        }
        if (onFulfilled !== undefined) {
            onFulfilled(response);
        }
    }, function (exception) {
        if (__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.debug) {
            console.log('throws: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(exception));
        }
        if (onRejected !== undefined) {
            onRejected(exception);
        }
    });
};

// 减少拼接的逻辑, 前缀路径固定
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.nvGetDefaultJson = function (suffix, onFulfilled, onRejected) {
    __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.nvGetJson('static/data/', suffix, onFulfilled, onRejected);
};

// 加载字符串
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.nvLoadStrings = function (context, onNvStringsLoaded) {
    if (__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.nvStrings === undefined) {
        __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.nvForceLoadStrings(context, onNvStringsLoaded);
    } else {
        if (context !== undefined) {
            context['nvStrings'] = __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.nvStrings;
        }
        if (onNvStringsLoaded !== undefined) {
            onNvStringsLoaded(__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.nvStrings);
        }
    }
};

__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.nvForceLoadStrings = function (context, onNvStringsLoaded) {
    this.nvGetDefaultJson('strings.json', function (response) {
        __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.nvStrings = response.data;
        if (context !== undefined) {
            context['nvStrings'] = response.data;
        }
        if (onNvStringsLoaded !== undefined) {
            onNvStringsLoaded(context);
        }
    });
};

__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.nvSetLocale = function (locale) {
    if (locale !== undefined) {
        if (__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.debug) {
            console.log('Vue.prototype.locale: set to -> ' + locale);
        }
        this.locale = locale;
        this.nvForceLoadStrings();
    }
};

// 默认加载方法
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.nvOnLoad = function (onNvStringsLoaded) {
    this.nvParseUrlParams();
    this.nvLoadStrings(this, function (context) {
        if (__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.titleKey !== undefined && __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.nvStrings !== undefined && __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.nvStrings[__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.titleKey] !== undefined) {
            document.title = __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.nvStrings[__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.titleKey];
        }
        onNvStringsLoaded(context);
    });
};

__WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].beforeEach(function (to, from, next) {
    if (to.meta !== undefined && to.meta.title_key !== undefined) {
        document.title = '';
        __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.titleKey = to.meta.title_key;
    } else {
        document.title = '';
    }
    next();
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_7__App___default.a }
});

/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app'
});

/***/ }),

/***/ 77:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'activities',
    data: function data() {
        return {
            emptyListTip: '',
            isEmptyList: true,
            list: []
        };
    },
    mounted: function mounted() {
        this.nvOnLoad(this.onCreate);
        // 加载活动数据
        this.loadActivities();
    },

    methods: {
        onCreate: function onCreate(context) {
            context.emptyListTip = context.nvStrings['activities_empty_list'];
        },
        loadActivities: function loadActivities() {
            var context = this;
            // 从本地文件中读取活动列表
            this.nvGetDefaultJson('activities.json', function (response) {
                // 数据更新时 UI 也会更新, 在这里可以手动设置一些测试数据来看浏览器页面的变化
                context.list = response.data['activities'];
                // or that.list = response.data.activities
                context.isEmptyList = context.list.length < 1;
            }, function (exception) {});
        }
    }
});

/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'activities',
    data: function data() {
        return {
            // 评分提示语
            commentTip: '',
            // 提交按钮文案
            submitText: 'Submit',
            // 好评的标准(用户评分 > 标准 = 好评)
            goodScore: 0,
            // 用户评分
            userScore: 0,
            // 差评相关内容, 会通过 saveData 反馈给 Native, Native 注意拦截实现
            badReview: {},
            // 好评相关内容
            goodReview: {},
            stars: [{
                active: false
            }, {
                active: false
            }, {
                active: false
            }, {
                active: false
            }, {
                active: false
            }],
            form: {}
        };
    },
    mounted: function mounted() {
        // 加载资源, 解析参数
        this.nvOnLoad(function (context) {});
        var that = this;
        // 从本地读取评分规则
        this.nvGetDefaultJson('rules.json', function (response) {
            var rules = response.data;
            // 找到匹配的评分规则, 由活动类型决定
            var rule = rules[that.activityType];
            // 赋值好评/差评内容
            that.goodReview = rule['goodReview'];
            that.badReview = rule['badReview'];
            // 根据规则填充页面内容
            if (rule !== undefined && rule !== '') {
                document.title = rule.title;
                that.commentTip = rule.comment;
                that.submitText = rule.submit;
                that.goodScore = rule.score;
            }
        });
    },

    methods: {
        starClicked: function starClicked(idx) {
            console.log('## star ' + idx + ' clicked');
            this.userScore = idx + 1;
            var i = 0;
            for (; i <= idx; i++) {
                this.stars[i].active = true;
            }
            for (; i < 5; i++) {
                this.stars[i].active = false;
            }
        },
        openRouter: function openRouter(routerMethod, routerURL, routerCfg) {
            // console.log('routerCfg: ' + JSON.stringify(routerCfg))
            var resultReview = routerCfg.resultReview;
            if (resultReview.redirect !== undefined && resultReview.redirect !== '') {
                // 如果存在页面重定向, 则跳转到重定向页面
                location.href = resultReview.redirect;
            } else {
                // 如果是 Android/iOS, 路由到特定页面
                delete routerCfg.resultReview;
                console.log('routerCfg: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(routerCfg));
                if (window.nvJsAPI !== undefined) {
                    window.nvJsAPI.ui.openRouter(routerURL, routerMethod, routerCfg);
                } else {
                    console.log('## nvJsAPI not found');
                }
            }
        },
        submit: function submit() {
            var routerURL = '/menu/activities/comment';
            var routerMethod = 'submit';
            var routerCfg = {
                userScore: this.userScore,
                goodScore: this.goodScore,
                activityId: this.activityId,
                activityType: this.activityType,
                resultReview: this.userScore > this.goodScore ? this.goodReview : this.badReview
                // 提交前, 将表单内容(路由配置)交由 Native 层保存, 以便在需要重定向的页面中读取, 供 nvjsinject-*.js 用
            };if (window.nvJsAPI !== undefined) {
                window.nvJsAPI.sys.saveData('commentForm', routerCfg, 0);
            }
            this.openRouter(routerMethod, routerURL, routerCfg);
        },
        back: function back() {
            this.$router.go(-1);
        }
    }
});

/***/ }),

/***/ 79:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

//  var scene = document.getElementById('scene');
//  var parallax = new Parallax(scene);
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Error404',
    data: function data() {},
    mounted: function mounted() {},

    methods: {}
});

/***/ })

},[75]);


// WEBPACK FOOTER //
// static/js/app.26f08936e1319db6a48f.js